/* eslint-disable max-len */
import React from 'react';

const Print: React.FC<object> = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.5 4V1.75H8.5V4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.5 8H2.25A0.75 0.75 0 0 1 1.5 7.25V5A0.75 0.75 0 0 1 2.25 4.25H9.75A0.75 0.75 0 0 1 10.5 5V7.25A0.75 0.75 0 0 1 9.75 8H8.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.5 6.75H8.5V10.25H3.5V6.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Print;
